import { Component, EventEmitter, Output, effect, inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { IBucketItem, ITags } from "../models/bucket-item.model";
import { BreadcrumbDataService } from "../../../main/layout/tool-bar/breadcrumb-service/breadcrumb-data.service";
import { IBreadcrumbItem } from "../../../main/layout/tool-bar/model/breadcrumb.model";
import { DataService } from "../service/data.service";
import { RowDataService } from "../service/row-data.service";
import { MasterDataService } from "../../../dynamic-controls/master-data-service";
import { map } from "rxjs";
import { MatDivider } from "@angular/material/divider";
import { PackageFolderTagsGeneralComponent } from "../package-folder-tags-general/package-folder-tags-general.component";

@Component({
    selector: "app-package-folder-tags",
    templateUrl: "./package-folder-tags.component.html",
    styleUrls: ["./package-folder-tags.component.scss"],
    imports: [MatDivider, PackageFolderTagsGeneralComponent]
})
export class PackageFolderTagsComponent {
  @Output() cancelPackageFolderTagsOperation: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  public title = "Add Tag to Multiple Package Folders";
  public count = 0;
  public currentBreadcrumbItem: Partial<IBreadcrumbItem> = {};
  private readonly breadcrumbDataService = inject(BreadcrumbDataService);
  private readonly dataService = inject(DataService);
  private readonly controlsService = inject(MasterDataService);
  private readonly rowDataService = inject(RowDataService);
  public clickedBucketItem: Partial<IBucketItem> = null;
  public selectedBucketItems: Partial<IBucketItem>[] = [];
  public commonSelectedTags: Partial<ITags>[] = [];
  private readonly _breadcrumb = toSignal(this.breadcrumbDataService.getCurrentBreadCrumbItem());
  private readonly _allSelected = toSignal(this.dataService.getAllSelectedData());
  private readonly _clickedRow = toSignal(this.rowDataService.getClickedRowData());
  @Output() tagsUpdated = new EventEmitter<boolean>();
  @Output() unSelectFoldersForMultipleTags = new EventEmitter<boolean>();

  packageFolderTags$ = this.controlsService
    .GetMasterData()
    .pipe(
      map((controls) =>
        controls
          .filter(control => {
            const scopeValue = `${control.Scope ?? ''}`.toLowerCase();
            const isPackageFolderScope = scopeValue === 'packagefolderlevel';
            return !control.IsObsolete && isPackageFolderScope;
          })
          .sort((a, b) => a.TagsDisplayOrder - b.TagsDisplayOrder)
      )
    );

  constructor() {
    effect(() => {
      const item = this._breadcrumb();
      if (item != null) this.currentBreadcrumbItem = item;
    });
    effect(() => {
      const data = this._allSelected() ?? [];
      this.selectedBucketItems = data.filter(item =>
        item.FolderType === 'StudyPackage' || item.FolderType === 'FacilityPackage'
      );
      this.count = this.selectedBucketItems.length;
      this.commonSelectedTags = this.getCommonTags(this.selectedBucketItems);
    });
    effect(() => {
      const data = this._clickedRow();
      if (data) this.clickedBucketItem = data;
    });
  }

  public handleCancelOperation(value: boolean): void {
    this.cancelPackageFolderTagsOperation.emit(value);
  }

  public onTagsUpdated(updated: boolean): void {
    this.tagsUpdated.emit(updated);
  }

  private getCommonTags(items: Partial<IBucketItem>[]): Partial<ITags>[] {
    if (items.length !== 1) {
      return [];
    }

    return (items[0].TagsWithValues ?? items[0].Tags ?? [])
      .filter(tag => !!tag.TagKey && !!tag.TagValue)
      .map(tag => ({ ...tag }));
  }
}
